import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CreateLink,
  ListsToggle,
  MDXEditor,
  UndoRedo,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  quotePlugin,
  toolbarPlugin
} from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';

export function Editor({
  editorState,
  onChange,
  readOnly = true,
}: {
  editorState: string
  onChange?: (value: string) => void;
  readOnly: boolean
}) {
  return (
    <MDXEditor
      className='w-full prose lg:prose-base'
      autoFocus
      readOnly={readOnly}
      placeholder={"Enter Text here"}
      onChange={(value) => onChange && onChange(value)}
      markdown={editorState}
      plugins={[
        headingsPlugin(),
        listsPlugin(),
        linkPlugin(),
        linkDialogPlugin(),
        quotePlugin(),
        toolbarPlugin({
          toolbarContents: () => (
            <>
              {' '}
              <UndoRedo />
              <BoldItalicUnderlineToggles />
              <BlockTypeSelect />
              <ListsToggle />
              <CreateLink />
            </>
          )
        })
      ]}
    />
  )
}